import { VoiceboxRequestMessage } from 'bones/constants/voicebox/message';
import { VoiceboxSettings } from 'bones/constants/voicebox/settings';

export const getSettingsFromRequestMessage = (
  message: VoiceboxRequestMessage,
  defaultSettings: VoiceboxSettings
): VoiceboxSettings => ({
  databaseId: message.context.database_id ?? defaultSettings.databaseId,
  model: message.context.model ?? defaultSettings.model,
  namedGraphs: message.context.named_graphs ?? defaultSettings.namedGraphs,
  reasoning: message.context.reasoning ?? defaultSettings.reasoning,
});
